import SiteLayout from "@/components/feature/SiteLayout";
import CtaBand from "@/components/feature/CtaBand";
import Hero from "@/pages/home/components/Hero";
import WorldsIntro from "@/pages/home/components/WorldsIntro";
import ChefSection from "@/pages/home/components/ChefSection";
import LocavoreSection from "@/pages/home/components/LocavoreSection";
import JourneysSection from "@/pages/home/components/JourneysSection";
import BringSection from "@/pages/home/components/BringSection";
import JournalSection from "@/pages/home/components/JournalSection";

export default function Home() {
  return (
    <SiteLayout>
      <Hero />
      <WorldsIntro />
      <ChefSection />
      <LocavoreSection />
      <JourneysSection />
      <BringSection />
      <JournalSection />
      <CtaBand
        eyebrow="The Invitation"
        title={
          <>
            Have a place Eddie
            <br />
            <span className="italic text-primary-400">should discover?</span>
          </>
        }
        text="Invite him to your event. Hire him for your table. Or nominate a locavore destination the world should know about."
        primary={{ label: "Invite Eddie", to: "/invite-eddie" }}
        secondary={{ label: "Submit a Locavore", to: "/submit-a-locavore" }}
      />
    </SiteLayout>
  );
}